import React from "react";

import "./Quote.css";

const Quote = () => (
  <div className="quote">
    <h1>
      “Não há maneira de agradecer a Deus pela visão, do que dar ajuda a alguém
      que não a possui.”
    </h1>
    <h3>Helen Keller</h3>
  </div>
);

export default Quote;
